module.exports = __webpack_public_path__ + "img/bullet_point.ec17d8ed.png";